const zhCN = {
  'banner.introduction': '提供企业即时、互动的视觉化人才发展整合方案',
  'banner.introduction.covid': ' ',
  'banner.introduction.post-covid': '',
  'featureList.onboarding': '员工入职计划',
  'featureList.onboarding.content':
    '阶段性的入职流程，让新人快速有条理的熟悉公司和基本作业，流程等。',
  'featureList.structuredTraining': '结构化的培训。',
  'featureList.structuredTraining.content':
    '整合线上、线下培训资源，通过权限控管，使员工便于聚焦在职务能力的提升上。',
  'featureList.behaviorRecongnition': '员工激励',
  'featureList.behaviorRecongnition.content':
    '以游戏化的方式，达成实时、频繁的多维度正向反馈，营造企业内部正向循环的氛围。',
  'featureList.personalDevelopment': '个人化的发展',
  'featureList.personalDevelopment.content':
    '为潜力员工量身定制教练和个人发展计划，根据追踪个人指标的弱项，有针对性的提升相对应的能力。',
  'featureList.organizationalCommunication': '组织沟通',
  'featureList.organizationalCommunication.content':
    '便于追踪的公告读取、员工反馈、调研、以及以部门为单位的聊天群，双向的管道提升组织沟通成效。',
  'featureList.realtimePerformanceTracking': '实时绩效追踪',
  'featureList.realtimePerformanceTracking.content':
    '实时、量化的指标追踪，部属日常表现连续不间断，结合个人化的发展和结构化的培训，让评鉴与考核不再只有开始和结束。',
  'featureList.companySuccessionPlanning': '企业接班人计划',
  'featureList.companySuccessionPlanning.content':
    '通过长期追踪员工的各项表现进行分类与搜寻，成为企业补齐职位空缺的有效工具。',
  copyRight: 'Copyright @ 2020 AMPOS Solutions Inc. All Rights Reserved',
  'product.title': '产品',
  'product.introduction':
    '为适应外在环境的快速变化和突发挑战，AMPOS以整合性的人才管理为出发点，为企业构建一套能够实时反应员工状态，让管理者和员工在第一时间给予激励与协助的综合解决方案，以提升人才管理的实时性和有效性。',
  'product.download': '请点击下载按钮来安装应用程序',
  'product.store.ios': 'App Store',
  'product.store.google': 'Google Play',
  'product.store.360': '360手機助手',
  'product.store.tencent': '腾讯应用宝',
  'product.store.baidu': '百度手机助手',
  'product.store.huawei': '华为应用市场',
  'product.store.oppo': 'OPPO软件商店',
  'product.store.xiaomi': '小米应用商店',
  'product.store.flyme': 'Flyme开放平台',
  'product.store.wandoujia': '豌豆荚',
  'service.intro.title': '服务',
  'service.intro.subtitle': '顾问咨询和项目服务',
  'service.intro.content1': `AMPOS的跨国团队拥有丰富的经验，可以为世界級大型公司提供基于Amazon Web Services（AWS）的基于云的企业软件解决方案。 我们从全球领先的技术公司招聘了经验丰富的产品经理，工程师和解决方案交付专家。
    \nAMPOS团队在SaaS企业软件开发和AWS服务方面具备深厚专业知识的公司，並提供顾问咨询和项目的服务。
    \n聆听我们的首席技术官兼首席架构师，了解我们如何在AWS全球和中国地区管理我们的解决方案架构
    `,
  'service.intro.content2':
    "We recruited experienced product managers, engineers, and solution delivery experts from leading global technology companies.AMPOS provides consulting and project based services to companies in need of leveraging AMPOS team's deep expertise in SaaS enterprise software development and AWS services.",
  'service.intro.content3':
    '亞馬遜雲平台曾針對我們的使用案例專訪過我們的CTO和Chief Architect',
  'service.content.title': '咨询和专案项目:',
  'service.content.list1': '云端数据管理和架构咨询',
  'service.content.list2': '企业级软件开发',
  'service.content.list3': ' ',
  'service.content.content':
    '我们的团队专长包括：敏捷/项目管理，软件架构师，业务分析，UX / UI设计, Kotlin, Java, iOS, NodeJS, Python, Android, Angular, AWS, ReactJS, Flutter。合作伙伴，并具有以下亚马逊云平台服务的深度了解和实际实施经验',
  'contact.phone': '电话. ',
  'contact.taipeiCompanyName': '易智能股份有限公司台湾分公司',
  'contact.taipeiAddress': '台北市大安区仁爱路三段141号6楼',
  'contact.chinaCompanyName': 'AMPOS – 中国',
  'contact.chinaAddress': '上海市静安区泰兴路89号4F',
  'contact.bangkokCompanyName': 'AMPOS – 曼谷',
  'contact.bangkokAddress':
    '699 Modernform Tower, 22nd Floor, Unit No. 2204 Srinakarindr Road, Phatthanakan,  Suanluang,  Bangkok  10250',
  'contact.form.title': '联络我们',
  'contact.form.name': '姓名',
  'contact.form.email': '电子邮件',
  'contact.form.phone': '电话',
  'contact.form.comment': '內容',
  'contact.form.submit': '点击发送',
  'contact.form.validation.required': 'Required',
  'contact.form.validation.invalid.email': 'Invalid email address',
  'contact.form.validation.invalid.phone': 'Phone number is not valid',
  'about.header': '关于我们',
  'about.main.content':
    '致力于为HR伙伴们研发协助其推动人才发展的各种工具并提供发挥人才最大价值的企业多元化解决方案。想要节约运营成本，提高运营绩效，培育和发掘内部人才，精准管理到各层人员？我们都能做到，且超乎想象。面临无从改变的发展困境，我们的顾问团队将会为您提供量身定做且专业的全套解决方案。\n目前已成功帮助制造、餐饮、零售等行业提升其人力资源运用，并在上海、台北、曼谷设立办公室，深耕国际市场，打造世界级的研发环境。',
  'about.team.title': '我们的团队',
  'about.team.introduction':
    '我们是一个快速成长的新创公司，聚集了互联网相关领域的专业人才，他们曾任职于Amazon，IBM，MicroStrategy，PayPal，PwC，Thomson Reuters，Trend Micro 等大型科技公司，且毕业于哈佛商学院，卡内基梅隆等世界知名高等学府。团队成员拥有极佳默契，经常脑力激荡发挥潜力以创造创新价值，专注于探究市场与行业发展趋势，用心聆听客户的需求去拟定企业解决方案及项目规划，帮助企业创造核心价值，因为我们相信客户的成功就是我们最大的成功。',
  'about.press.header': 'AMPOS in the Press',
  'career.header.title': 'Career',
  'career.benefit.title': 'BENEFIT',
  'career.benefit.list1':
    'Performance-based bonus every 6 months (i.e. twice per year)',
  'career.benefit.list2': 'Flexible working hours',
  'career.benefit.list3':
    'Ten (10) paid vacation days, with a 2-day increment each year, up to a maximum of 20 days total',
  'career.benefit.list4': 'Free drinks and snacks',
  'career.benefit.list5': 'Free team polo shirts in different colors',
  'career.benefit.list6':
    'Relaxed working environment (e.g. Xbox 360, PS3, and ping pong table)',
  'career.benefit.list7': 'Team outings and teamwork activities',
  'career.benefit.list8': 'Developer, IT, creative/design training program',
  'career.benefit.list9':
    'Opportunity to work in foreign countries (some positions only)',
  'career.benefit.list10':
    'Opportunity to participate in offline marketing events with compensation of 2,000 THB per day',
  'career.benefit.list11':
    'Employee referral program of 20,000 THB per successful referral, for both Introducer and referrals',
  'career.benefit.list12': 'Group health insurance and social security',
  'header.home': '主页',
  'header.product': '产品',
  'header.solution': '方案',
  'header.service': '服务',
  'header.about': '关于我们',
  'header.career': '人才招聘',
  'header.contact': '联系我们',
  'header.language': '语言',
  'header.download': '下载',
  'email.successMsg': '我们已收到您的需求，将尽快与您回覆',
  'email.errorMsg': '目前服务出了问题，请稍后再试',
  faq: '帮助中心',
};
export default zhCN;
